<template>
  <v-app light>
    <v-layout row>
      <v-flex xs12 md6>
        <div :class="{'login' : $vuetify.breakpoint.smAndUp}" class="test-hotfix" v-if="!$store.state.logged">
          <v-layout hidden-sm-and-down></v-layout>
          <v-layout row justify-space-between>
            <v-flex md2></v-flex>
            <v-flex xs12 sm8 style="width: 400px;">
              <div v-if="loadingRegister" class="text-xs-center">
                <v-progress-circular :size="70" :width="1" indeterminate class="primary--text"></v-progress-circular>
              </div>
              <v-card :flat="$vuetify.breakpoint.xsOnly" v-else-if="!registering">
                <v-card-title primary-title class="primary">
                  <v-layout row justify-space-between>
                    <v-flex lg2></v-flex>
                    <img 
                      :src="domaine.indexOf('targetfirst') !== -1
                        ? `${domaine}/static/logo_tf.png`
                        : `${domaine}/watcheezy/static/logo_tf.png`"
                      style="max-width:100%;max-height:200px;width:auto;height:auto;"
                    />
                    <v-flex lg2></v-flex>
                  </v-layout>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <form autocomplete="on">
                      <v-text-field 
                        v-model="email" 
                        :label="$t('email') | cap"
                        type="email"
                        data-vv-name="email"
                        required
                        v-validate="'required|email'"
                        :error="wzErrors.has('email')"
                        :error-messages="wzErrors.collect('email')"
                        prepend-icon="mail" 
                        @keyup.enter="login"
                        autofocus
                      ></v-text-field>
                      <v-text-field 
                        v-model="password" 
                        :label="$t('password') | cap" 
                        type="password" 
                        data-vv-name="password"
                        required 
                        v-validate="'required'"
                        :error="wzErrors.has('password')"
                        :error-messages="wzErrors.collect('password')"
                        prepend-icon="lock" 
                        @keyup.enter="login"
                      ></v-text-field>
                    </form>
                    <v-btn 
                      block
                      color="secondary" 
                      class="white--text" 
                      :loading="loadingLogin" 
                      :disabled="wzErrors.any() " 
                      @click="login()"
                    >{{ $t('login') }}</v-btn>
                    <v-checkbox
                      :label="$t('connectingOnline')"
                      v-model="settingsConnectStatusCookies"
                      color="primary"
                      :disabled="loadingLogin"
                    >
                    </v-checkbox>
                    <wz-switch-lang @change="updateLang"></wz-switch-lang>
                    <v-layout row wrap>
                      <v-flex xs12 lg6>
                        <v-btn
                          :disabled="loadingLogin"
                          flat
                          block
                          :href="`${domaine}/login/retrievepassword_fr.php`"
                        >
                          {{ $t('passwordForgotten') }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
              <v-card :flat="$vuetify.breakpoint.xsOnly" v-else>
                <v-card-title primary-title class="primary">
                  <v-layout row justify-space-between>
                    <v-flex lg2></v-flex>
                    <img :src="`${domaine}/static/logo_tf.png`" style="max-width:100%;max-height:200px;width:auto;height:auto;">
                    <v-flex lg2></v-flex>
                  </v-layout>
                </v-card-title>
                <v-container>
                  <v-card-text>
                    <form autocomplete="on">
                      <v-text-field 
                        v-model="url" 
                        prepend-icon="http" 
                        label="URL de votre site"
                        data-vv-name="url"
                        required 
                        v-validate="'required|url:require_protocol'"
                        :error="wzErrors.has('url')"
                        :error-messages="wzErrors.collect('url')"
                      ></v-text-field>
                      <v-text-field 
                        v-model="email" 
                        prepend-icon="mail" 
                        label="Mail de contact" 
                        readonly
                        required
                      ></v-text-field>
                      <v-text-field 
                        v-model="password" 
                        :label="$t('password')" 
                        type="password" 
                        data-vv-name="password"
                        required 
                        v-validate="'required|min:12'"
                        :error="wzErrors.has('password')"
                        :error-messages="wzErrors.collect('password')"
                        prepend-icon="lock"
                        loading
                      >
                        <v-progress-linear slot="progress" :value="progress" height="5" :color="color"></v-progress-linear>
                      </v-text-field>
                      <v-text-field 
                        v-model="confirmPassword" 
                        label="Confirmez votre mot de passe" 
                        type="password" 
                        :rules="[rules.confirmPassword]"
                        data-vv-name="confirmPassword"
                        required 
                        v-validate="'required'"
                        :error="wzErrors.has('confirmPassword')"
                        :error-messages="wzErrors.collect('confirmPassword')"
                        prepend-icon="lock"
                      ></v-text-field>
                      <v-text-field 
                        v-model="firstName"
                        prepend-icon="accessibility"
                        label="Votre prénom"
                        data-vv-name="firstName"
                        required 
                        v-validate="'required'"
                        :error="wzErrors.has('firstName')"
                        :error-messages="wzErrors.collect('firstName')"
                      ></v-text-field>
                      <v-text-field 
                        v-model="lastName" 
                        prepend-icon="accessibility"
                        label="Votre nom"
                      ></v-text-field>
                      <v-text-field 
                        v-model="phone"
                        prepend-icon="phone"
                        label="Votre téléphone"
                      ></v-text-field>
                    </form>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      block
                      color="secondary" 
                      class="white--text" 
                      :loading="loadingLogin" 
                      :disabled="wzErrors.any() || confirmPassword != password" 
                      @click="register()"
                    >
                      S'inscrire !
                      <v-icon right dark>send</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-flex>
            <v-flex md2></v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex md6 hidden-sm-and-down>
        <iframe src="https://admin.targetfirst.com/login/news/news-4.html" width="100%" height="100%"></iframe>
      </v-flex>
    </v-layout>
  
    <!-- DIALOG SCRIPT -->
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="title primary white--text">{{ $t('congratulations') }}</v-card-title>
        <v-card-text>
          <span>{{ $t('registrationOk') }}</span>
          <v-textarea
            outline
            label="Votre script Target First"
            class="code-HTML"
            readonly
            :value="'<script type=\'text/javascript\' src=\'//www.watcheezy.net/deliver/targetfirst.js?wzkey=' + wzkey + '\'></script>'"
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            block
            color="secondary" 
            class="white--text" 
            :loading="loadingLogin" 
            :disabled="wzErrors.any() " 
            @click="login()"
          > {{ $t('login') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG STATUS DECONNEXION -->
    <v-dialog v-model="dialogDeconnexion" persistent  max-width="290">
      <v-card v-if="$store.state.reasonDeco">
        <v-card-title class="title primary white--text">{{ $t($store.state.reasonDeco.title) }}</v-card-title>
        <v-card-text>
          <div v-html="$t($store.state.reasonDeco.content)"></div>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            block
            color="primary" 
            flat
            @click="closeDialogDeco()"
          >ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SNACKBAR -->
    <v-snackbar v-model="snack.show" left>
      {{ snack.msg }}
      <v-btn flat :class="snack.context + '--text'" @click="snack.show = false">
        {{ snack.btn }}
        <span>
          <v-icon right v-if="snack.context == 'success'">check_circle</v-icon>
          <v-icon right v-else-if="snack.context == 'info'">info</v-icon>
          <v-icon right v-else-if="snack.context == 'warning'">warning</v-icon>
          <v-icon right v-else-if="snack.context == 'error'">error</v-icon>
        </span>
      </v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>
import _ from 'lodash'
import { DOMAINE } from '../constants'
import Vue from 'vue'
import { mapMutations } from 'vuex'
import VueGtm from 'vue-gtm'
Vue.use(VueGtm, {
})
export default {
  name: 'Login',
  data () {
    return {
      /**
       - Indique le domaine de l'appli
       - @type {String}
       */
      domaine: DOMAINE,
      /**
       * L'utilisateur géré lors de la connexion
       * @type {Object}
       */
      user: {
        /**
         * Indique si suite à la connexion
         * l'agent se trouve 'en ligne'
         * @type {Boolean}
         */
        // connectingOnline: true
      },
      /**
       * Indique si l'utilisateur tente de se connecter
       * @type {Boolean}
       */
      loadingLogin: false,
      /**
       * Indique si tentative de création de compte
       * @type {Boolean}
       */
      loadingRegister: false,
      /**
       * Affiche une dialog info deconnexion
       * @type {Boolean}
       */
      dialogDeconnexion: false,
      /**
       * Indique si la page est en mode registering
       * (création de compte)
       * @type {Boolean}
       */
      settingsConnectStatusCookies: true,
      registering: false,
      email: '',
      password: '',
      /**
       * En cas de création de licence
       */
      url: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
      rules: {
        confirmPassword: (v) => this.confirmPassword === this.password || this.$t('pwdsNotMatch')
      },
      /**
       * Indique si le dialog est affichée
       * @type {Boolean}
       */
      dialog: false,
      wzkey: '',
      /**
       * Snackbar
       * @type {Object}
       */
      snack: {
        show: false,
        msg: '',
        context: 'info',
        btn: 'fermer'
      }
    }
  },

  computed: {
    progress () {
      return Math.min(100, this.password.length * 10)
    },
    color () {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
    }
  },

  created () {
    // Redirection si vient de watcheezy.net
    if (window.location.origin.indexOf('www.watcheezy.net') > -1) {
      window.location.href = 'https://admin.targetfirst.com'
    }
    if (window.location.origin.indexOf('localhost') > -1) {
      this.email = 'demo@watcheezy.fr'
      this.password = '123456'
    }
    // Tests afin de savoir s'il s'agit d'une création de compte
    if ((this.$route.query.email && !_.isNil(this.$route.query.email) &&
      (this.$route.query.password && !_.isNil(this.$route.query.password)))) {
      this.email = this.$route.query.email
      this.password = this.$route.query.password
      this.login()
    } else if (this.$route.query.register && !_.isNil(this.$route.query.register)) {
      this.loadingRegister = true
      this.email = this.$route.query.register
      this.axios.get('get/check_register.php?email=' + this.email)
      .then(res => {
        this.registering = true
        this.$gtm.trackView('LoginRegister', 'currentpath')
        this.$gtm.trackEvent({
          event: null, // Event type [default = 'interaction'] (Optional)
          category: 'arrivé page creation de compte',
          action: 'email valider',
          label: this.email + ' est sur la page de creation de compte',
          value: 10,
          noninteraction: false // Optional
        })
      })
      .catch(() => {
        this.email = ''
        window.location = `${DOMAINE}/#/login`
      })
      .then(() => {
        this.loadingRegister = false
      })
    }
    // Test pour savoir si déjà connecté
    if (this.$store.getters.logged) {
      this.$store.dispatch('logout')
    }
  },

  mounted () {
    if (this.$store.state.reasonDeco) {
      this.dialogDeconnexion = true
    }
    this.settingsFromCookies()
  },

  methods: {
    ...mapMutations(['SET_REASON_DECO']),

    closeDialogDeco () {
      console.log('close', this.dialogDeconnexion)
      this.dialogDeconnexion = false
      this.SET_REASON_DECO(null)
    },

    settingsFromCookies () {
      this.settingsConnectStatusCookies = this.$cookie.get('wz-connecting-start') === 'true' || false
    },

    login () {
      if (!this.wzErrors.any()) {
        this.loadingLogin = true
        this.axios.get('get/login.php?email=' + this.email + '&password=' + this.password)
        .then(response => {
          const data = response.data
          const session = data.session
          if (data.redirect) {
            window.location.href = data.redirect
          }
          this.user.id = session.user_id
          this.user.fname = session.user_firstname
          this.user.lname = session.user_lastname
          this.user.mail = session.user_mail
          this.user.mailContact = session.user_emailcontact
          this.user.job = session.user_job
          this.user.phone = session.user_tel
          this.user.title = session.user_title
          this.user.connectingOnline = this.settingsConnectStatusCookies

          this.user.key = session.key
          this.user.dispo = session.user_dispo
          this.user.canBeUnavailable = session.user_can_be_unavailable === '1'
          // this.user.age = session.user_age
          // this.user.firm = session.user_firm
          // this.user.web = session.user_web
          // this.user.adress = session.user_adress
          // this.user.zip = session.user_zip
          // this.user.city = session.user_city
          // this.user.country = session.user_country
          // this.user.activity = session.user_activity
          this.user.rights = session.user_rights
          this.user.chatsMax = session.user_nb_chat_max
          // this.user.device = session.user_device
          this.user.chatNotif = session.user_chat_notif_onoff
          this.user.priority = session.user_priority
          this.user.keywords = session.user_keywords
          // this.user.closeChatOnOff = session.user_closechat_onoff
          // this.user.closeChatAction = session.user_closechat_action
          // this.user.closeChatDetails = session.user_closechat_details
          this.user.multiSite = session.user_multisite
          this.user.eezylead = session.eezylead_specialtable
          this.user.licAllKeys = session.user_licAllKeys
          // this.user.licUrl = session.user_lic_url
          // this.user.licSite = session.user_lic_site
          // this.user.licValid = session.user_lic_valid
          // this.user.licUrlValid = session.user_lic_url_valid
          // this.user.licKeyId = session.user_lic_key_id
          // this.user.licKeyIdLang = session.user_lic_id_lang
          // this.user.licKeyIdUrl = session.user_lic_id_url
          // this.user.host = session.user_host
          this.user.licenceId = session.licence_id
          // this.user.licCurentNbPage = session.lic_current_nb_page
          this.user.licLang = session.lic_lang
          // this.user.compEmail = session.comp_email
          // this.user.compEmailCopy = session.comp_email_copy
          // this.user.compTel = session.comp_tel
          this.user.callbackOnOff = session.callbackOnOff
          // this.user.cobrowsingOnOff = session.cobrowsingOnOff
          // this.user.superistypingOnOff = session.superistypingOnOff
          this.user.licSpecialtable = session.lic_specialtable
          this.user.licEezyLead = session.lic_eezy_lead
          this.user.chatOnOff = session.chatOnOff
          // this.user.licCallbackActivated = session.LIC_CALLBACK_ACTIVATED
          // this.user.eezyleadAdmin = session.eezylead_admin
          // this.user.rtcOnOff = session.rtcOnOff
          this.user.usr_is_bot = session.usr_is_bot
          this.user.usr_time_transfert = session.usr_time_transfert
          this.user.usr_bo_notif = session.usr_bo_notif

          // referent de facturation
          this.user.entRefFacturation = session.ent_ref_facturation
          // expiration CB
          this.user.cbExpiration = session.ent_cb_expiration

          // entreprise
          this.user.entKey = session.ent_key
          this.user.entId = session.ent_id
          this.user.entName = session.ent_name
          // this.user.entCoord = session.ent_coord
          this.user.entDateCreation = session.ent_datecreation
          this.user.entEezySubscription = session.ent_eezysubscription
          this.user.entEezyExpiry = session.ent_eezyexpiry
          // this.user.entComment = session.ent_comment
          this.user.entLevel = session.ent_level
          // this.user.entEezy = session.ent_eezy
          // this.user.entIsValid = session.ent_isvalid
          // this.user.entContact = session.ent_contact
          this.user.entNbPageTotal = _.toInteger(session.ent_nbpagetotal)
          this.user.entNbPageThisMonth = session.ent_nbpagethismonth
          this.user.entNbPageMax = session.ent_nbpagemax
          this.user.entOptionPage = session.ent_optionpage
          this.user.entNbAgent = session.ent_nbagent
          // this.user.entOptionAgent = session.ent_optionagent
          this.user.entNbSite = session.ent_nbsite
          // this.user.entOptionSite = session.ent_optionsite
          // this.user.entCiblage = session.ent_ciblage
          // this.user.entOptionCiblage = session.ent_optionciblage
          // this.user.entNbChat = session.ent_nbchat
          // this.user.entNbiIterpell = session.ent_nbinterpell
          // this.user.entTpsVisio = session.ent_tpsvisio
          // this.user.entNbPageHistoric = session.ent_nbpagehistoric
          // this.user.entRefresh = session.ent_refresh
          // this.user.entMultiUrl = session.ent_multiurl
          // this.user.entRedis = session.ent_redis
          this.user.entBeta = session.ent_beta === '1'
          this.user.facebookToken = session.facebook_token
          this.user.facebookPage = session.facebook_page
          // this.user.entConfigured = session.ent_configured
          this.user.entSF = session.ent_sf
          this.user.entSFUsr = session.ent_sf_usr
          this.user.entSFPwd = session.ent_sf_pwd
          this.user.entSFToken = session.ent_sf_token
          this.user.entZD = session.ent_zd
          this.user.entZDUsr = session.ent_zd_usr
          this.user.entZDDomain = session.ent_zd_domain
          this.user.entZDToken = session.ent_zd_token
          this.user.entOptionPush = session.ent_optionpush
          this.user.entGA = session.ent_ga
          this.user.entGAUsr = session.ent_ga_usr
          this.user.entSlack = session.ent_slack
          this.user.entSlackUsr = session.ent_slack_usr
          // this.user.autoAnswser = session.DSK_FIRSTMSG_MSG
          // this.user.entAllLic = session.ent_all_lic
          this.user.maxVisitors = _.toInteger(session.ent_max_visitors)
          this.user.hideTabVisitors = session.ent_hide_tab_visitors
          this.user.surcisLicience = session.ent_surcis_licence
          this.user.smsOn = session.smsOn
          this.user.consoLastDays = session.consoLastDays
          this.user.installProgress = session.installProgress
          this.user.remainingSteps = session.remainingSteps
          this.user.ongoingTuto = false
          this.user.tutoQuited = false

          // temps de travail pour la journée
          this.user.tempsTravail = session.user_time_day
          this.user.jourHebdoTravail = session.user_day_hebdo

          // BRIDES UTILISATEUR
          if (session.user_brides) {
            // si le chat max est bridé à 1, si bride COMPTE_CONSEILLERS_CHAT_MAX est à 0
            if (!session.user_rights_compte_conseillers_chat_max) {
              this.user.chatsMax = 1
            }
            this.user.brides = [
              {'brideName': 'trafic', 'status': session.user_rights_trafic},
              {'brideName': 'trafic_visiteurs', 'status': session.user_rights_trafic_visiteurs},
              {'brideName': 'trafic_discussions', 'status': session.user_rights_trafic_discussions},
              {'brideName': 'trafic_monitoring', 'status': session.user_rights_trafic_monitoring},
              {'brideName': 'trafic_monitoring_chat_superviseur', 'status': session.user_rights_trafic_monitoring_chat_superviseur},
              {'brideName': 'stats', 'status': session.user_rights_stats},
              {'brideName': 'stats_audience', 'status': session.user_rights_stats_audience},
              {'brideName': 'stats_conversations', 'status': session.user_rights_stats_conversations},
              {'brideName': 'stats_chatbot', 'status': session.user_rights_stats_chatbot},
              {'brideName': 'stats_chatbot_histo', 'status': session.user_rights_stats_chatbot_histo},
              {'brideName': 'stats_conseillers', 'status': session.user_rights_stats_conseillers},
              {'brideName': 'stats_callback', 'status': session.user_rights_stats_callback},
              {'brideName': 'stats_ventes', 'status': session.user_rights_stats_ventes},
              {'brideName': 'stats_ventes_chatbot', 'status': session.user_rights_stats_ventes_chatbot},
              {'brideName': 'stats_ventes_callback', 'status': session.user_rights_stats_ventes_callback},
              {'brideName': 'stats_ventes_lead', 'status': session.user_rights_stats_ventes_lead},
              {'brideName': 'stats_leads', 'status': session.user_rights_stats_leads},
              {'brideName': 'stats_leads_getquanty', 'status': session.user_rights_stats_leads_getquanty},
              {'brideName': 'stats_leads_chaleur', 'status': session.user_rights_stats_leads_chaleur},
              {'brideName': 'stats_satisfaction', 'status': session.user_rights_stats_satisfaction},
              {'brideName': 'stats_rapports', 'status': session.user_rights_stats_rapports},
              {'brideName': 'compte', 'status': session.user_rights_compte},
              {'brideName': 'compte_conseillers', 'status': session.user_rights_compte_conseillers},
              {'brideName': 'compte_conseillers_chat_max', 'status': session.user_rights_compte_conseillers_chat_max},
              {'brideName': 'compte_conseillers_transfert', 'status': session.user_rights_compte_conseillers_transfert_auto},
              {'brideName': 'compte_conseillers_prioritaire', 'status': session.user_rights_compte_conseillers_prioritaire},
              {'brideName': 'compte_conseillers_api', 'status': session.user_rights_compte_conseillers_api},
              {'brideName': 'compte_conseillers_black_list', 'status': session.user_rights_compte_conseillers_black_list},
              {'brideName': 'compte_conseillers_indispo', 'status': session.user_rights_compte_conseillers_indispo},
              {'brideName': 'compte_conseillers_notifbo', 'status': session.user_rights_compte_conseillers_notifbo},
              {'brideName': 'compte_sites', 'status': session.user_rights_compte_sites},
              {'brideName': 'compte_attribution', 'status': session.user_rights_compte_attribution},
              {'brideName': 'ciblage', 'status': session.user_rights_ciblage},
              {'brideName': 'media', 'status': session.user_rights_media},
              {'brideName': 'media_phrases', 'status': session.user_rights_media_phrases},
              {'brideName': 'media_phrases_completion', 'status': session.user_rights_media_phrases_completion},
              {'brideName': 'media_push', 'status': session.user_rights_media_push},
              {'brideName': 'parametre', 'status': session.user_rights_parametre},
              {'brideName': 'parametre_apercu', 'status': session.user_rights_parametre_apercu},
              {'brideName': 'parametre_apercu_couleurs', 'status': session.user_rights_parametre_apercu_couleurs},
              {'brideName': 'parametre_apercu_dimensions', 'status': session.user_rights_parametre_apercu_dimensions},
              {'brideName': 'parametre_apercu_coins', 'status': session.user_rights_parametre_apercu_coins},
              {'brideName': 'parametre_apercu_position', 'status': session.user_rights_parametre_apercu_position},
              {'brideName': 'parametre_apercu_mobile_position', 'status': session.user_rights_parametre_apercu_mobile_position},
              {'brideName': 'parametre_apercu_desk', 'status': session.user_rights_parametre_apercu_desk},
              {'brideName': 'parametre_apercu_mobile_desk', 'status': session.user_rights_parametre_apercu_mobile_desk},
              {'brideName': 'parametre_apercu_sideon', 'status': session.user_rights_parametre_apercu_sideon},
              {'brideName': 'parametre_apercu_hide_moyen', 'status': session.user_rights_parametre_apercu_hide_moyen},
              {'brideName': 'parametre_apercu_conseiller', 'status': session.user_rights_parametre_apercu_conseiller},
              {'brideName': 'parametre_apercu_bot', 'status': session.user_rights_parametre_apercu_bot},
              {'brideName': 'parametre_apercu_hide_liste', 'status': session.user_rights_parametre_apercu_hide_liste},
              {'brideName': 'parametre_apercu_geoloc', 'status': session.user_rights_parametre_apercu_geoloc},
              {'brideName': 'parametre_apercu_lang', 'status': session.user_rights_parametre_apercu_lang},
              {'brideName': 'parametre_apercu_title_close', 'status': session.user_rights_parametre_apercu_title_close},
              {'brideName': 'parametre_apercu_title_offline', 'status': session.user_rights_parametre_apercu_title_offline},
              {'brideName': 'parametre_apercu_title_online', 'status': session.user_rights_parametre_apercu_title_online},
              {'brideName': 'parametre_apercu_message1', 'status': session.user_rights_parametre_apercu_message1},
              {'brideName': 'parametre_apercu_message2', 'status': session.user_rights_parametre_apercu_message2},
              {'brideName': 'parametre_affichage', 'status': session.user_rights_parametre_affichage},
              {'brideName': 'parametre_affichage_perso', 'status': session.user_rights_parametre_affichage_perso},
              {'brideName': 'parametre_affichage_perso_cible', 'status': session.user_rights_parametre_affichage_perso_cible},
              {'brideName': 'parametre_affichage_horaire', 'status': session.user_rights_parametre_affichage_horaire},
              {'brideName': 'parametre_affichage_url', 'status': session.user_rights_parametre_affichage_url},
              {'brideName': 'parametre_chat', 'status': session.user_rights_parametre_chat},
              {'brideName': 'parametre_chat_invitation', 'status': session.user_rights_parametre_chat_invitation},
              {'brideName': 'parametre_chat_formprechat', 'status': session.user_rights_parametre_chat_formprechat},
              {'brideName': 'parametre_chat_premiermessage', 'status': session.user_rights_parametre_chat_premiermessage},
              {'brideName': 'parametre_chat_reponseauto', 'status': session.user_rights_parametre_chat_reponseauto},
              {'brideName': 'parametre_chat_editlead', 'status': session.user_rights_parametre_chat_editlead},
              {'brideName': 'parametre_chat_istyping', 'status': session.user_rights_parametre_chat_istyping},
              {'brideName': 'parametre_chat_iframe', 'status': session.user_rights_parametre_chat_iframe},
              {'brideName': 'parametre_callback', 'status': session.user_rights_parametre_callback},
              {'brideName': 'parametre_bot', 'status': session.user_rights_parametre_bot},
              {'brideName': 'parametre_cobrowsing', 'status': session.user_rights_parametre_cobrowsing},
              {'brideName': 'parametre_cobrowsing_cobrowsing', 'status': session.user_rights_parametre_cobrowsing_cobrowsing},
              {'brideName': 'parametre_cobrowsing_mirroring', 'status': session.user_rights_parametre_cobrowsing_mirroring},
              {'brideName': 'parametre_ecommerce', 'status': session.user_rights_parametre_ecommerce},
              {'brideName': 'parametre_connecteur', 'status': session.user_rights_parametre_connecteur},
              {'brideName': 'parametre_connecteur_facebook', 'status': session.user_rights_parametre_connecteur_facebook},
              {'brideName': 'parametre_connecteur_messenger', 'status': session.user_rights_parametre_connecteur_messenger},
              {'brideName': 'parametre_connecteur_salseforce', 'status': session.user_rights_parametre_connecteur_salseforce},
              {'brideName': 'parametre_connecteur_zendesk', 'status': session.user_rights_parametre_connecteur_zendesk},
              {'brideName': 'parametre_connecteur_analytics', 'status': session.user_rights_parametre_connecteur_analytics},
              {'brideName': 'parametre_connecteur_slack', 'status': session.user_rights_parametre_connecteur_slack},
              {'brideName': 'parametre_connecteur_vyte', 'status': session.user_rights_parametre_connecteur_vyte},
              {'brideName': 'parametre_push', 'status': session.user_rights_parametre_push},
              {'brideName': 'parametre_push_auto', 'status': session.user_rights_parametre_push_auto},
              {'brideName': 'parametre_analytics', 'status': session.user_rights_parametre_analytics},
              {'brideName': 'parametre_recall', 'status': session.user_rights_parametre_recall},
              {'brideName': 'parametre_sms', 'status': session.user_rights_parametre_sms},
              {'brideName': 'parametre_absence', 'status': session.user_rights_parametre_absence},
              {'brideName': 'parametre_messaging', 'status': session.user_rights_parametre_messaging},
              {'brideName': 'multisite_indicateur', 'status': session.user_rights_multisite_indicateur}
            ]
          }
          // // Desk
          // this.user.deskId = session.deskid
          // this.user.deskOnoff = session.desk_onoff
          // this.user.deskTabPos = session.desk_tab_pos
          // this.user.deskAskGeoloc = session.desk_ask_geoloc
          // this.user.deskGeteLang = session.desk_getelang
          // this.user.deskTabSide = session.desk_tab_side
          // this.user.deskTabColor = session.desk_tab_color
          // this.user.deskTabMsg = session.desk_tab_msg
          // this.user.deskTabMsgLight = session.desk_tab_msg_light
          // this.user.deskTabMsgJson = session.desk_tab_msg_json
          // this.user.deskAgentPhoto = session.desk_agent_photo
          // this.user.DeskOptions = session.DSK_OPTIONS
          // this.user.DeskOptionsTimeout = session.desk_options_timeout
          // this.user.deskOptions2 = session.desk_options2
          // this.user.deskHideMobile = session.desk_hide_mobile
          // this.user.deskSchedules = session.desk_schedules
          this.user.deskAutochat = session.desk_autochat
          this.user.askGeoloc = session.desk_ask_geoloc
          // this.user.deskAutochatUrl = session.desk_autochat_url
          // this.user.deskAutochatUrlOnOff = session.desk_autochat_url_onoff
          // this.user.deskPushOnOff = session.desk_pushonoff
          // this.user.deskPushDelay = session.desk_pushdelay
          // this.user.deskPushimg = session.desk_pushimg
          // this.user.deskPushTitle = session.desk_pushtitle
          // this.user.deskPushMsg = session.desk_pushmsg
          // this.user.deskCobrowsing = session.desk_cobrowsing
          // this.user.deskCobroShowMouseAgent = session.desk_cobro_show_mouse_agent
          // this.user.deskCobroAskVisitor = session.desk_cobro_ask_visitor
          this.user.connectFromAdmin = session.connectFromAdmin
          this.user.colleagues = session.user_colleagues
          this.user.user_sites = session.user_sites
          this.user.bots = session.user_bots
          this.user.filterFront = session.ent_filter_front
          // la langue du backoffice sera celle choisie dans le select
          this.user.lang = this.$i18n.locale
          this.$cookie.set('wz-lang', this.$i18n.locale, { expires: '1Y' })
          // avatar
          this.user.avatar = null
          let avatar = session.avatarfilename
          if (avatar !== 'unknown.gif' && !_.isNil(avatar) && avatar !== '') {
            this.user.avatar = avatar
          }
          console.log('this.user', this.user)
          this.$store.dispatch('loginUser', this.user)
          // efface le cookie de memo des dialogbox d'alert quota
          this.$cookie.set('memoDialogQuota', '0', { expires: '10h' })
          this.$cookie.set('memoDialogC2C', '0', { expires: '10h' })
          this.$cookie.set('memoDialogExpireCB', '0', { expires: '10h' })
          this.getMessagesAttentes()
        })
        .catch(resp => {
          this.loadingLogin = false
          // console.log('resp.response', resp.response)
          if (resp.response.status === 401) {
            this.snack.msg = 'Account disabled'
          } else {
            this.snack.msg = this.$t('emailPassNotMatch')
          }
          this.snack.context = 'error'
          this.snack.show = true
          // console.log(resp.response)
        })
      } else {
        this.snack.msg = this.$t('notFilled')
        this.snack.context = 'error'
        this.snack.show = true
      }
    },
    /**
     * Met à jour la langue du backoffice
     * @param {string} newLang : nouvelle langue choisie
     */
    updateLang (newLang) {
      this.$i18n.locale = newLang
    },
    // ------------------------------------------------------------------------------
    // Chargement des messages en attentes
    // ------------------------------------------------------------------------------
    getMessagesAttentes () {
      // this.loadingGet = true
      this.loadingLogin = true
      this.axios
      .get(
        'get/chats_abscence.php?agentId=' +
          this.user.id
      )
      .then(response => {
        // console.log('response', response)
        this.user.listeMessages = response.data
        // this.listeMessages = response.data
        // console.log('this.listeMessages', this.listeMessages)
        // parse le tableau pour trouve le visiteur qui vient d'un reseau social
        _.forEach(
          this.user.listeMessages,
          (allVisiteurs, key) => {
            if (allVisiteurs.network === 'facebook') {
              // console.log('visiteur facebook : ', allVisiteurs.visiteurName)
              let dataVisiteur = {'visiteurData': allVisiteurs, 'key': key}
              this.getAvatarVisiteur(dataVisiteur)
              // console.log('listeMessages key ', key)
            }
          }
        )
        // console.log('this.listeMessages', this.listeMessages)
        // this.loadingGet = false
        this.loadingLogin = false
        // console.log('length', this.listeMessages.length)
      })
      .catch(_ => {
        // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
      })
      .then(_ => {
      })
    },
    // ------------------------------------------------------------------------------
    // Ajout de l'avatar si message en attente reseaux sociaux
    // ------------------------------------------------------------------------------
    getAvatarVisiteur (data) {
      // console.log('data', data)
      this.axios
      .get(
        'get/chats_abscence_avatar.php?visitorId=' +
          data.visiteurData.visiteurID
      )
      .then(response => {
        // console.log('response', response.data)
        if (response.data) {
          // return response.data
          data.visiteurData.profile_pic = response.data
          this.user.listeMessages.splice(data.key, 1, data.visiteurData) // change l'etat du over sur le drop
          // console.log('this.listeMessages', this.user.listeMessages)
        }
      })
      .catch(_ => {
        // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
      })
      .then(_ => {
      })
    },

    register () {
      this.$validator.validateAll()
      if (this.wzErrors.any()) {
        this.snack.msg = this.$t('notFilled')
        this.snack.context = 'error'
        this.snack.show = true
        return
      }
      // Création de la licence
      let dataToPost = new window.FormData()
      dataToPost.append('url', this.url)
      dataToPost.append('email', this.email)
      dataToPost.append('password', this.password)
      dataToPost.append('firstName', this.firstName)
      dataToPost.append('lastName', this.lastName)
      dataToPost.append('phone', this.phone)
      this.loadingLogin = true
      this.axios.post('post/register.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.wzkey = response.data
        this.dialog = true
        this.trackEvent()
        // NICE TO HAVE
        // envoi par mail de la ligne de script
        //  à un technicien
      })
      .catch(() => {
        this.snack.msg = this.$t('error')
        this.snack.context = 'error'
        this.snack.show = true
      })
      .then(() => {
        this.loadingLogin = false
      })
    },
    retrieve () {
      // Création de la licence
      let dataToPost = new window.FormData()
      dataToPost.append('email', this.email)
      dataToPost.append('lang', this.$i18n.locale)
      this.loadingLogin = true
      this.axios.post('post/pwd_retrieve.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.dialogRetrieve = false
      })
      .catch(() => {
        this.snack.msg = this.$t('error')
        this.snack.context = 'error'
        this.snack.show = true
      })
      .then(() => {
        this.loadingLogin = false
      })
    },
    trackEvent () {
      this.$gtm.trackEvent({
        event: null, // Event type [default = 'interaction'] (Optional)
        category: 'register OK',
        action: 'Validation',
        label: 'finalisation inscription essai',
        value: 5000,
        noninteraction: false // Optional
      })
    }
  },
  watch: {
    settingsConnectStatusCookies (v) {
      this.$cookie.set('wz-connecting-start', v, { expires: '1Y' })
    }
  }
}
</script>

<style scoped>
  div#app {
      height: 100%;
  }
  /* image de fond */
  .login {
    height: 100%;
    background-color: #F9F4F9;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue